<!--  -->
<template>
  <div class="bcf6">
    <div class="container clearf">
      <div class="center-left">
        <div v-for="item in navData" :key="item.number" @click="gochild(item.path,item.number)" class="nav-item" :class="active == item.number ? 'center-active':''">
          <i class="iconfont fz18">{{item.icon}}</i><span>{{item.name}}</span>
        </div>
        
      </div>
      <div class="center-right">
        <transition name="el-fade-in-linear" mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
        navData:[
            {
                name:"认领学者",
                path:"claimscholar",
                number:0,
                icon:"\ue604"
            },
            {
                name:"学者信息",
                path:"information",
                number:1,
                icon:"\ue615"
            },
            {
                name:"我的评议",
                path:"mycomments",
                number:2,
                icon:"\ue60e"
            },
            {
                name:"站内消息",
                path:"stationnews",
                number:3,
                icon:"\ue64e"
            },
            {
                name:"主页设置",
                path:"settings",
                number:4,
                icon:"\ue645"
            },
        ],
        active:-1
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
      gochild(s,n){
          this.active = n
          this.$router.push({
              path:`/personalcenter/${s}`,
              query:{num: n}
          });
      }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
      this.active = this.$route.query.num;
      
     // console.log(this.$router.options.routes[0].children[3])
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
      
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style>
.fz18{
  font-size: 18px;
  color: #CCD2DF;
}
.center-active .fz18{
  color: #4267b2;
}
.bcf6 {
  background-color: #f6f6f6;
  padding: 20px 0;
}
.center-left,
.center-right {
  background-color: #fff;
  float: left;
  min-height: 800px;
}
.center-left {
  width: 256px;
  margin-right: 20px;
  padding: 30px;
}
.center-left .nav-item {
  margin-top: 8px;
  padding: 2px 0 8px 0;
  text-align: center;
  color: #444444;
  font-weight: 600;
  font-size: 14px;
  border-bottom: 1px solid #f2f2f5;
  cursor: pointer;
}
.center-left .nav-item span{
  margin-left: 20px;
}
.center-left .center-active {
  color: #4267b2;
}
.center-left .nav-item:first-child {
  margin-top: 0;
}
.center-left .nav-item:last-child {
  border-bottom: none;
}
.center-right {
  width: 800px;
  padding: 30px;
}
</style>


// WEBPACK FOOTER //
// src/view/personalCenter/personalcenter.vue